import React, { createContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';

import RiskAssessmentReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/risk-assessment.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(RiskAssessmentReducer, defaultState, asyncActions);
};

type IRiskAssessmentContext = ReturnType<typeof useReducer>;

const RiskAssessmentContext = createContext<Partial<IRiskAssessmentContext>>({
  state: defaultState,
}) as React.Context<IRiskAssessmentContext>;

const RiskAssessmentProvider: React.FC = ({ children }) => {
  const reducer = useReducer();
  return (
    <RiskAssessmentContext.Provider value={{ ...reducer }}>
      {children}
    </RiskAssessmentContext.Provider>
  );
};

export const useRiskAssessmentContext = () =>
  React.useContext(RiskAssessmentContext);

export type IUseRiskAssessmentContext = ReturnType<
  typeof useRiskAssessmentContext
>;

export { RiskAssessmentContext, RiskAssessmentProvider };
